import { FormattedNumber } from 'react-intl';
import StarFilled from '@alltrails/denali/icons/StarFilled';
import styles from './AverageRating.module.scss';

type AverageRatingProps = {
  averageRating: number;
};

const AverageRating = ({ averageRating }: AverageRatingProps) => {
  return (
    <div className={styles.container}>
      <span className={styles.ratingText}>
        <FormattedNumber minimumFractionDigits={1} value={averageRating} />
      </span>
      <StarFilled color="--color-text-primary" size="lg" />
    </div>
  );
};

export default AverageRating;
